import { FreightSimulation } from 'src/components/restructure/common/FreightSimulation'
import { useProductPageContext } from 'src/components/restructure/product/contexts/product-context'
import { FreightForm } from 'src/components/restructure/common/FreightSimulation/FreightForm'
import { useEffect, useMemo } from 'react'
import { useAddressContext } from 'src/components/checkout/steps/shipping/context/address-context'

export function Shipping() {
  const { postalCode, address } = useAddressContext()

  const { currentSku, setFreightSimulation } = useProductPageContext()

  const readyToGetFreightSimulation = address

  const items = useMemo(
    () => [
      {
        id: currentSku.itemId,
        seller: currentSku.sellerDefault.sellerId,
        quantity: 1,
      },
    ],
    [currentSku]
  )

  useEffect(() => {
    async function runFreightSimulation() {
      const storedCEP = postalCode

      if (storedCEP) {
        await setFreightSimulation(items, storedCEP)
      }
    }

    runFreightSimulation()
  }, [items, postalCode, setFreightSimulation])

  return (
    <section
      id="shipping"
      className="flex flex-col items-center justify-center gap-2"
    >
      <FreightForm />
      {readyToGetFreightSimulation && <FreightSimulation />}
    </section>
  )
}
